"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractModuleId = exports.setUpListAiEngineForModule = exports.defaultBanditState = void 0;
const interfaces_1 = require("./interfaces");
function defaultBanditState() {
    return {
        previousState: 0,
        currentState: 0,
    };
}
exports.defaultBanditState = defaultBanditState;
/*
 * Determine `listAiEngineId` using one of the following methods, in order of
 * precedence:
 *
 * 1. `forceAiTypes` flag + `aiTypes` set: when `aiTypes` is provided and the
 *    `forceAiTypes` flag is true, use the `aiTypes` set, converting it into
 *    `listAiEngineId`. (Note: there's a one-to-one mapping between `AIType` and
 *    `AIEngineID`.)
 *
 * 2. `moduleAiEnginesSetUp` config: when the `moduleAiEnginesSetUp` module
 *    config is available and the `forceAiTypes` flag is NOT true, generate the
 *    list from `moduleAiEnginesSetUp`. (Note: even if `aiTypes` is provided,
 *    `moduleAiEnginesSetUp` takes precedence. This is done for backwards
 *    compatibility reasons.)
 *
 * 3. `aiTypes` set: when `aiTypes` is provided and the `moduleAiEnginesSetUp`
 *    module config is not available, generate the list from `aiTypes`.
 *
 * 4. Default value: if neither `moduleAiEnginesSetUp` nor `aiTypes` is
 *    available, use a predefined default for `listAiEngineId`.
 */
function setUpListAiEngineForModule(moduleConfig, moduleId, aiTypes, forceAiTypes) {
    // Case 2:
    let baseModuleConfig = moduleConfig[moduleId];
    if (baseModuleConfig.moduleAiEnginesSetUp &&
        (forceAiTypes !== true || !aiTypes)) {
        let dicoAiEngineOrAgent = baseModuleConfig.moduleAiEnginesSetUp;
        let listAiEngineId = new Set();
        let listAiAgentId = [];
        Object.keys(dicoAiEngineOrAgent).forEach((aiEngineOrAgentID) => {
            if (dicoAiEngineOrAgent[aiEngineOrAgentID] &&
                Object.values(interfaces_1.AIEnginesIDs).includes(aiEngineOrAgentID)) {
                listAiEngineId.add(aiEngineOrAgentID);
            }
            else if (Object.values(interfaces_1.AIAgentsIDs).includes(aiEngineOrAgentID)) {
                listAiAgentId.push(aiEngineOrAgentID);
            }
        });
        return {
            listAiEngineId: listAiEngineId,
            listAiAgentId: listAiAgentId,
        };
    }
    // Case 1 & 3
    if (aiTypes) {
        return {
            listAiEngineId: new Set([...aiTypes].map((aiType) => interfaces_1.AITypeToAIEnginesIDs[aiType])),
            listAiAgentId: [
                interfaces_1.AIAgentsIDs.studentActivityMonitorAgent,
                interfaces_1.AIAgentsIDs.messageManegementAgent,
            ],
        };
    }
    // Case 4 (default)
    return {
        listAiEngineId: new Set([interfaces_1.AIEnginesIDs.zpdes]),
        listAiAgentId: [
            interfaces_1.AIAgentsIDs.studentActivityMonitorAgent,
            interfaces_1.AIAgentsIDs.messageManegementAgent,
        ],
    };
}
exports.setUpListAiEngineForModule = setUpListAiEngineForModule;
function extractModuleId(event) {
    try {
        if (event.data && event.data.moduleId) {
            return event.data.moduleId;
        }
        else if (event.categoryData && event.categoryData.parentItems) {
            return event.categoryData.parentItems[2].id;
        }
    }
    catch (_a) {
        throw Error("Cannot extract moduleId from event" + JSON.stringify(event));
    }
}
exports.extractModuleId = extractModuleId;
